export interface CourseWindow {
  state: string;
  startAt: Date | null;
  endAt: Date | null;
}

export function courseIsActive(course: CourseWindow, semester: {startAt: Date; endAt: Date}, now: Date): boolean {
  return course.state === 'published' && now >= semester.startAt && now <= semester.endAt
    && now >= (course.startAt ?? semester.startAt) && now <= (course.endAt ?? semester.endAt);
}

export function activeCourseIds(courses: Record<string, CourseWindow>, semester: {startAt: Date; endAt: Date}, now: Date): string[] {
  return Object.keys(courses).filter(id => courseIsActive(courses[id]!, semester, now)).sort();
}
